export enum FirebaseErrorCode {
    emailAlreadyInUse = "auth/email-already-in-use",
    weakPassword = "auth/weak-password",
    manyRequests = "auth/too-many-requests",
    invalidCredential = "auth/invalid-credential",
    invalidEmail = "auth/invalid-email",
    invalidInvite = "auth/invalid-invite",
    forbiddenInvite = "auth/forbidden-invite",
    accessPermissions = "auth/access-permissions",
    invalidProvider = "auth/account-exists-with-different-credential",
    cancelPopup = "auth/cancelled-popup-request",
    closePopup = "auth/popup-closed-by-user"
}
